import * as React from "react";

export const UploadBox = ({ title, maxImages }) => {
    return (
        <div className="flex flex-col max-w-full rounded-none w-[535px]">
            <div className="flex flex-col justify-center px-14 py-16 bg-white rounded-md border border-solid border-slate-200 max-md:px-5 max-md:max-w-full">
                <div className="flex flex-col justify-center items-center">
                    <div className="flex overflow-hidden flex-col justify-center items-center px-14 py-6 max-w-full rounded-2xl border border-dashed border-zinc-900 border-opacity-10 w-[335px] max-md:px-5">
                        <div className="flex flex-col">
                            <img
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/834629b8d878db1193c92cc02cca3e24c1b566ac2a79a19c9a78d528eeeed38c?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                                alt=""
                                className="object-contain self-center w-8 aspect-square"
                            />
                            <div className="mt-1.5 text-base font-semibold opacity-70 max-md:mx-0.5 w-full">
                                {title}
                            </div>
                            <div className="mt-1.5 text-base font-medium opacity-40">
                                Maximum {maxImages} Media
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};